import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "@/app/utils/handleApiError";
import {
  fetchCargoTrackingMetadata,
  fetchTrackOrder,
} from "./shippingTracking.service";
import { RejectValueType } from "../redux/redux.types";
import {
  CargoTrackingMetadataResponse,
  CargoTrackingResultResponse,
  TrackOrderRequest,
} from "./shippingTracking.types";

export const getCargoTrackingMetadata = createAsyncThunk<
  CargoTrackingMetadataResponse,
  void,
  RejectValueType
>("shippingTracking/getMetadata", async (_, { rejectWithValue }) => {
  try {
    return await fetchCargoTrackingMetadata();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const trackOrder = createAsyncThunk<
  CargoTrackingResultResponse,
  TrackOrderRequest,
  RejectValueType
>("shippingTracking/trackOrder", async (data, { rejectWithValue }) => {
  try {
    return await fetchTrackOrder(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
